/* Evershine Jewels theme JS — progressive enhancement over plain form/link fallbacks. */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatted = withCommas + (parts[1] !== '00' ? '.' + parts[1] : '');
    return (format && format.indexOf('amount_no_decimals') > -1) ? withCommas : formatted;
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function showNotification(message) {
    var el = qs('#cart-notification');
    if (!el) return;
    el.querySelector('p').textContent = message;
    el.hidden = false;
    clearTimeout(showNotification._t);
    showNotification._t = setTimeout(function () { el.hidden = true; }, 3000);
  }

  /* ---------- Add to cart (AJAX with graceful fallback) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-add-to-cart-form]')) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (res) { return res.json(); })
      .then(function (item) {
        if (item.status) {
          showNotification(item.description || 'Could not add this item to your cart.');
          return;
        }
        showNotification((item.product_title || 'Item') + ' added to your cart');
        if (window.closeQuickView) window.closeQuickView();

        // Show "Checkout Now" popup above mobile bottom nav Cart button
        var mobileCheckoutPopup = qs('#mobile-checkout-popup');
        if (mobileCheckoutPopup) {
          mobileCheckoutPopup.hidden = false;
          clearTimeout(mobileCheckoutPopup._t);
          mobileCheckoutPopup._t = setTimeout(function () {
            mobileCheckoutPopup.hidden = true;
          }, 6000);
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  /* ---------- Quantity steppers (product page + cart page) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-increase], [data-qty-decrease]');
    if (!btn) return;
    var wrapper = btn.closest('[data-qty-stepper]');
    if (!wrapper) return;
    var input = wrapper.querySelector('input[type="number"], [data-qty-value]');
    if (!input) return;

    var isInput = input.tagName === 'INPUT';
    var current = parseInt(isInput ? input.value : input.textContent, 10) || 1;
    var next = btn.hasAttribute('data-qty-increase') ? current + 1 : Math.max(1, current - 1);

    if (isInput) {
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      input.textContent = next;
    }

    var cartKey = wrapper.getAttribute('data-cart-line-key');
    if (cartKey) updateCartLine(cartKey, next);
  });

  function updateCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) { return res.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }

  /* ---------- Cart line remove ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    var key = btn.getAttribute('data-cart-remove');
    updateCartLine(key, 0);
  });

  /* ---------- Mobile nav toggle ---------- */
  function setNavOpen(open) {
    var toggle = qs('[data-nav-toggle]');
    var nav = qs('[data-site-nav]');
    var overlay = qs('[data-nav-overlay]');
    if (!toggle || !nav) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    nav.classList.toggle('is-open', open);
    if (overlay) overlay.hidden = !open;
    document.body.classList.toggle('nav-is-locked', open);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-toggle]')) {
      var toggle = qs('[data-nav-toggle]');
      setNavOpen(toggle.getAttribute('aria-expanded') !== 'true');
      return;
    }
    if (e.target.closest('[data-nav-overlay]')) {
      setNavOpen(false);
      return;
    }
    var navLink = e.target.closest('[data-site-nav] a');
    if (navLink) setNavOpen(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setNavOpen(false);
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 900) setNavOpen(false);
  });

  /* ---------- Smooth scroll for in-page anchors ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-scroll-to]');
    if (!link) return;
    var target = document.getElementById(link.getAttribute('data-scroll-to'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
  });

  /* ---------- Initial cart count sync ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () { });
  });

  /* ---------- Money Formatting helper with Currency prefix/suffix preservation ---------- */
  function formatMoneyWithCurrency(cents, initialText) {
    var formatted = formatMoney(cents);
    if (!initialText) return formatted;
    var match = initialText.match(/^([^0-9]*)\d[\d,.]*([^0-9]*)$/);
    if (match) {
      return match[1] + formatted + match[2];
    }
    return formatted;
  }

  /* ---------- Variant selection update UI ---------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-variant-select]');
    if (!select) return;
    var form = select.closest('[data-add-to-cart-form]');
    if (!form) return;

    var variantsScript = form.querySelector('[data-product-variants]');
    if (!variantsScript) return;

    try {
      var variants = JSON.parse(variantsScript.textContent);

      // Get all selected values in order
      var selects = Array.prototype.slice.call(form.querySelectorAll('[data-variant-select]'));
      var selectedOptions = selects.map(function (sel) { return sel.value; });

      // Find the variant that matches all selected options
      var matchedVariant = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) {
            match = false;
            break;
          }
        }
        if (match) {
          matchedVariant = v;
          break;
        }
      }

      // Update form fields and UI
      var idInput = form.querySelector('[data-variant-id-input]');
      var addToCartBtn = form.querySelector('[data-add-to-cart]');
      var priceWrapper = document.querySelector('[data-price-wrapper]');

      if (matchedVariant) {
        if (idInput) idInput.value = matchedVariant.id;

        // --- Variant Image Switching for Main Product Image ---
        var mainImg = document.getElementById('ProductMainImage');
        var allThumbs = document.querySelectorAll('[data-thumb-for="ProductMainImage"]');
        var matchedThumb = null;
        var variantImgSrc = null;

        // Check if variant has associated image
        var varImgId = null;
        if (matchedVariant.featured_image) {
          if (typeof matchedVariant.featured_image === 'object') {
            varImgId = matchedVariant.featured_image.id || null;
            variantImgSrc = matchedVariant.featured_image.src || null;
          } else if (typeof matchedVariant.featured_image === 'string') {
            variantImgSrc = matchedVariant.featured_image;
          }
        } else if (matchedVariant.featured_media && matchedVariant.featured_media.preview_image) {
          variantImgSrc = matchedVariant.featured_media.preview_image.src || null;
          varImgId = matchedVariant.featured_media.id || null;
        }

        // Try finding matching thumbnail by image ID
        if (varImgId) {
          matchedThumb = document.querySelector('[data-thumb-for="ProductMainImage"][data-image-id="' + varImgId + '"]');
        }

        // Fallback 1: Match image alt text with selected option value (e.g. Color)
        if (!matchedThumb && selectedOptions.length > 0) {
          allThumbs.forEach(function (thumb) {
            if (matchedThumb) return;
            var altText = (thumb.getAttribute('data-image-alt') || '').toLowerCase().trim();
            if (altText) {
              selectedOptions.forEach(function (optVal) {
                if (optVal && altText.indexOf(optVal.toLowerCase().trim()) !== -1) {
                  matchedThumb = thumb;
                }
              });
            }
          });
        }

        // Fallback 2: Match by filename or color keywords (e.g. Red, Black, Green, Gold, Purple, Pink)
        if (!matchedThumb && selectedOptions.length > 0) {
          var colorKeywords = {
            'red': ['9738', 'red', 'ruby', 'crimson'],
            'green': ['9739', 'green', 'emerald'],
            'gold': ['9742', 'gold', 'yellow', 'champagne', 'amber'],
            'purple': ['9741', 'purple', 'violet', 'magenta', 'plum'],
            'black': ['9743', 'black', 'noir', 'dark'],
            'pink': ['9740', 'pink', 'rose', 'blush']
          };

          selectedOptions.forEach(function (optVal) {
            if (matchedThumb || !optVal) return;
            var optLower = optVal.toLowerCase().trim();
            var keywords = colorKeywords[optLower] || [optLower];

            allThumbs.forEach(function (thumb) {
              if (matchedThumb) return;
              var hrefLower = (thumb.getAttribute('href') || '').toLowerCase();
              var altLower = (thumb.getAttribute('data-image-alt') || '').toLowerCase();
              for (var k = 0; k < keywords.length; k++) {
                if (hrefLower.indexOf(keywords[k]) !== -1 || altLower.indexOf(keywords[k]) !== -1) {
                  matchedThumb = thumb;
                  break;
                }
              }
            });
          });
        }

        // Fallback 3: If counts match (e.g. 6 variants & 6 images), map by variant index
        if (!matchedThumb && variants.length === allThumbs.length) {
          var vIdx = variants.indexOf(matchedVariant);
          if (vIdx >= 0 && allThumbs[vIdx]) {
            matchedThumb = allThumbs[vIdx];
          }
        }

        // If matched thumbnail found, use its high-res URL
        if (matchedThumb) {
          variantImgSrc = matchedThumb.getAttribute('href');
        }

        // Apply new image to main image
        if (mainImg && variantImgSrc) {
          if (variantImgSrc.indexOf('//') === 0) variantImgSrc = 'https:' + variantImgSrc;
          mainImg.setAttribute('src', variantImgSrc);
          mainImg.removeAttribute('srcset');
        }

        // Update active thumbnail border
        if (allThumbs.length > 0) {
          allThumbs.forEach(function (t) {
            t.classList.remove('is-active');
            t.style.borderColor = 'var(--border)';
          });
          if (matchedThumb) {
            matchedThumb.classList.add('is-active');
            matchedThumb.style.borderColor = 'var(--accent)';
          }
        }

        // Update Price display
        if (priceWrapper) {
          var priceEl = priceWrapper.querySelector('[data-product-price]');
          var compareEl = priceWrapper.querySelector('[data-product-compare-price]');

          if (priceEl) {
            priceEl.textContent = formatMoneyWithCurrency(matchedVariant.price, priceEl.textContent);
          }

          if (compareEl) {
            if (matchedVariant.compare_at_price > matchedVariant.price) {
              compareEl.textContent = formatMoneyWithCurrency(matchedVariant.compare_at_price, compareEl.textContent);
              compareEl.style.display = 'inline';
            } else {
              compareEl.style.display = 'none';
            }
          }
        }

        // Update button state
        if (addToCartBtn) {
          if (matchedVariant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = 'Add to Cart';
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Sold Out';
          }
        }
      } else {
        // No matching variant found
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Unavailable';
        }
      }
    } catch (err) {
      console.error('Error updating variant selection:', err);
    }
  });

  /* ---------- Product Thumbnail image switcher ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-thumb-for]');
    if (!link) return;
    e.preventDefault();
    var targetId = link.getAttribute('data-thumb-for');
    var targetImg = document.getElementById(targetId);
    if (!targetImg) return;
    var newSrc = link.getAttribute('href');
    targetImg.setAttribute('src', newSrc);
    targetImg.removeAttribute('srcset');

    // Highlight active thumbnail
    var allThumbs = document.querySelectorAll('[data-thumb-for="' + targetId + '"]');
    allThumbs.forEach(function (t) {
      t.classList.remove('is-active');
      t.style.borderColor = 'var(--border)';
    });
    link.classList.add('is-active');
    link.style.borderColor = 'var(--accent)';

    // Sync variant dropdown if clicked thumbnail belongs to a variant
    var imgId = link.getAttribute('data-image-id');
    var form = document.querySelector('[data-add-to-cart-form]');
    var variantsScript = form ? form.querySelector('[data-product-variants]') : null;
    if (variantsScript) {
      try {
        var variants = JSON.parse(variantsScript.textContent);
        var matchingVar = null;

        // 1. Match by variant image ID
        if (imgId) {
          matchingVar = variants.find(function (v) {
            return (v.featured_image && String(v.featured_image.id) === String(imgId)) ||
                   (v.featured_media && String(v.featured_media.id) === String(imgId));
          });
        }

        // 2. Match by color keywords in href or alt
        if (!matchingVar) {
          var colorKeywords = {
            'red': ['9738', 'red', 'ruby'],
            'green': ['9739', 'green', 'emerald'],
            'gold': ['9742', 'gold', 'yellow', 'champagne'],
            'purple': ['9741', 'purple', 'violet'],
            'black': ['9743', 'black', 'noir'],
            'pink': ['9740', 'pink', 'rose']
          };
          var hrefLower = (link.getAttribute('href') || '').toLowerCase();
          var altLower = (link.getAttribute('data-image-alt') || '').toLowerCase();

          variants.forEach(function (v) {
            if (matchingVar) return;
            var vTitle = (v.title || '').toLowerCase().trim();
            var keywords = colorKeywords[vTitle] || [vTitle];
            for (var k = 0; k < keywords.length; k++) {
              if (hrefLower.indexOf(keywords[k]) !== -1 || altLower.indexOf(keywords[k]) !== -1) {
                matchingVar = v;
                break;
              }
            }
          });
        }

        // 3. Fallback: match by index
        if (!matchingVar && allThumbs.length === variants.length) {
          var tIdx = Array.prototype.indexOf.call(allThumbs, link);
          if (tIdx >= 0 && variants[tIdx]) {
            matchingVar = variants[tIdx];
          }
        }

        if (matchingVar && matchingVar.options) {
          var selects = Array.prototype.slice.call(form.querySelectorAll('[data-variant-select]'));
          var optionChanged = false;
          selects.forEach(function (sel, idx) {
            if (matchingVar.options[idx] && sel.value !== matchingVar.options[idx]) {
              sel.value = matchingVar.options[idx];
              optionChanged = true;
            }
          });
          if (optionChanged && selects[0]) {
            selects[0].dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      } catch (err) { }
    }
  });

  /* ---------- Sticky Header Scroll Logic ---------- */
  function initScrollHeader() {
    var header = qs('.site-header');
    if (!header) return;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        header.classList.add('site-header--scrolled');
      } else {
        header.classList.remove('site-header--scrolled');
      }
    });
  }

  /* ---------- Image loading complete class toggler ---------- */
  function initImageLoaders() {
    qsa('img').forEach(function (img) {
      var container = img.closest('.product-card__media, .category-card__media, picture, .hero__media, .product-detail__media');
      if (!container) return;
      if (img.complete) {
        container.classList.add('is-loaded');
      } else {
        img.addEventListener('load', function () {
          container.classList.add('is-loaded');
        });
        img.addEventListener('error', function () {
          container.classList.add('is-loaded');
        });
      }
    });
  }

  /* ---------- Premium Quick View Implementation ---------- */
  var qvModal = qs('#QuickViewModal');
  var qvImage = qs('#qv-image');
  var qvVendor = qs('#qv-vendor');
  var qvTitle = qs('#qv-title');
  var qvPrice = qs('#qv-price');
  var qvDescription = qs('#qv-description');
  var qvVariantIdInput = qs('#qv-variant-id');
  var qvVariantsContainer = qs('#qv-variants-container');
  var qvAddButton = qs('#qv-add-button');
  var qvProductData = null;

  window.openQuickView = function (handle) {
    if (!qvModal) return;

    // Fetch product details
    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        qvProductData = product;

        // Populate modal data
        if (qvImage) {
          qvImage.src = product.featured_image;
          qvImage.alt = product.title;
        }
        if (qvVendor) qvVendor.textContent = product.vendor;
        if (qvTitle) qvTitle.textContent = product.title;

        // Format money helper
        var priceFormatted = 'Rs. ' + (product.price / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
        if (qvPrice) {
          if (product.compare_at_price > product.price) {
            var compareFormatted = 'Rs. ' + (product.compare_at_price / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
            qvPrice.innerHTML = '<span class="price-current">' + priceFormatted + '</span> <s class="price-compare">' + compareFormatted + '</s>';
          } else {
            qvPrice.innerHTML = '<span class="price-current">' + priceFormatted + '</span>';
          }
        }

        // Strip HTML from description for modal
        if (qvDescription) {
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = product.description;
          qvDescription.textContent = tempDiv.textContent || tempDiv.innerText || "";
        }

        // Render variant options
        if (qvVariantsContainer) {
          qvVariantsContainer.innerHTML = '';

          if (product.variants.length > 1 && product.options) {
            product.options.forEach(function (option, index) {
              var wrap = document.createElement('div');
              wrap.className = 'quickview-modal__option-wrap';

              var label = document.createElement('label');
              label.textContent = option.name;
              label.setAttribute('for', 'qv-option-' + index);

              var select = document.createElement('select');
              select.id = 'qv-option-' + index;
              select.className = 'quickview-modal__select';
              select.dataset.optionIndex = index;

              option.values.forEach(function (val) {
                var opt = document.createElement('option');
                opt.value = val;
                opt.textContent = val;
                select.appendChild(opt);
              });

              select.addEventListener('change', updateQVVariant);

              wrap.appendChild(label);
              wrap.appendChild(select);
              qvVariantsContainer.appendChild(wrap);
            });
          }
        }

        // Initial variant update
        updateQVVariant();

        // Open modal
        qvModal.classList.add('is-active');
        qvModal.setAttribute('aria-hidden', 'false');
      })
      .catch(function (err) {
        console.error('Failed to load Quick View product', err);
      });
  };

  window.closeQuickView = function () {
    if (!qvModal) return;
    qvModal.classList.remove('is-active');
    qvModal.setAttribute('aria-hidden', 'true');
    if (qvImage) qvImage.src = '';
  };

  function updateQVVariant() {
    if (!qvProductData) return;

    // Find active selects
    var selects = Array.prototype.slice.call(qvModal.querySelectorAll('.quickview-modal__select'));
    var selectedOptions = selects.map(function (sel) { return sel.value; });

    var matchedVariant = null;
    if (qvProductData.variants.length === 1) {
      matchedVariant = qvProductData.variants[0];
    } else {
      for (var i = 0; i < qvProductData.variants.length; i++) {
        var v = qvProductData.variants[i];
        var isMatch = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) {
            isMatch = false;
            break;
          }
        }
        if (isMatch) {
          matchedVariant = v;
          break;
        }
      }
    }

    if (matchedVariant) {
      if (qvVariantIdInput) qvVariantIdInput.value = matchedVariant.id;

      // Update Quick View image to variant image
      if (qvImage) {
        var qvSrc = null;
        if (matchedVariant.featured_image) {
          qvSrc = typeof matchedVariant.featured_image === 'object' 
            ? (matchedVariant.featured_image.src || null) 
            : matchedVariant.featured_image;
        } else if (matchedVariant.featured_media && matchedVariant.featured_media.preview_image) {
          qvSrc = matchedVariant.featured_media.preview_image.src || null;
        }

        if (qvSrc) {
          if (qvSrc.indexOf('//') === 0) qvSrc = 'https:' + qvSrc;
          qvImage.src = qvSrc;
        }
      }

      // Update price text
      var priceFormatted = 'Rs. ' + (matchedVariant.price / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
      if (qvPrice) {
        if (matchedVariant.compare_at_price > matchedVariant.price) {
          var compareFormatted = 'Rs. ' + (matchedVariant.compare_at_price / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
          qvPrice.innerHTML = '<span class="price-current">' + priceFormatted + '</span> <s class="price-compare">' + compareFormatted + '</s>';
        } else {
          qvPrice.innerHTML = '<span class="price-current">' + priceFormatted + '</span>';
        }
      }

      // Update add to cart button state
      if (qvAddButton) {
        if (matchedVariant.available) {
          qvAddButton.textContent = 'Add to Cart';
          qvAddButton.removeAttribute('disabled');
        } else {
          qvAddButton.textContent = 'Sold Out';
          qvAddButton.setAttribute('disabled', 'disabled');
        }
      }
    } else {
      if (qvAddButton) {
        qvAddButton.textContent = 'Unavailable';
        qvAddButton.setAttribute('disabled', 'disabled');
      }
    }
  }

  /* ---------- Search Modal Handler ---------- */
  window.openSearchModal = function () {
    var modal = qs('#SearchModal');
    if (modal) {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      var input = modal.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 100);
    }
  };

  window.closeSearchModal = function () {
    var modal = qs('#SearchModal');
    if (modal) {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
    }
  };

  /* ---------- Live Predictive Search Handler ---------- */
  function initPredictiveSearch() {
    var searchInput = qs('#search-modal-input');
    var resultsContainer = qs('#search-modal-results');
    if (!searchInput || !resultsContainer) return;

    var debounceTimer = null;

    function renderResults(products, query) {
      if (!products || products.length === 0) {
        resultsContainer.innerHTML = '<div class="search-modal__empty">No products found matching "' + query + '".</div>';
        resultsContainer.style.display = 'block';
        return;
      }

      var html = '<div class="search-modal__grid">';
      products.slice(0, 6).forEach(function (p) {
        var imgUrl = p.image || (p.featured_image ? p.featured_image.url || p.featured_image : '') || (p.images && p.images[0] ? p.images[0].src || p.images[0] : '');
        var priceVal = parseFloat(p.price) || (p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0);
        var priceFormatted = 'Rs. ' + priceVal.toLocaleString('en-US', { minimumFractionDigits: 2 });
        
        var compareHtml = '';
        var compareVal = parseFloat(p.compare_at_price || p.compare_at_price_min) || (p.variants && p.variants[0] ? parseFloat(p.variants[0].compare_at_price) : 0);
        if (compareVal > priceVal) {
          var compareFormatted = 'Rs. ' + compareVal.toLocaleString('en-US', { minimumFractionDigits: 2 });
          compareHtml = ' <s class="price-compare">' + compareFormatted + '</s>';
        }

        html += '<a href="' + (p.url || ('/products/' + p.handle)) + '" class="search-modal__item">';
        if (imgUrl) {
          html += '<img src="' + imgUrl + '" alt="' + (p.title || '') + '" class="search-modal__item-img">';
        } else {
          html += '<div class="search-modal__item-placeholder">💎</div>';
        }
        html += '<div class="search-modal__item-info">';
        html += '<div class="search-modal__item-title">' + (p.title || 'Product') + '</div>';
        html += '<div class="search-modal__item-price"><span class="price-current">' + priceFormatted + '</span>' + compareHtml + '</div>';
        html += '</div>';
        html += '</a>';
      });
      html += '</div>';
      resultsContainer.innerHTML = html;
      resultsContainer.style.display = 'block';
    }

    function doSearch() {
      var query = searchInput.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 1) {
        resultsContainer.innerHTML = '';
        resultsContainer.style.display = 'none';
        return;
      }

      debounceTimer = setTimeout(function () {
        resultsContainer.innerHTML = '<div class="search-modal__loading">Searching products...</div>';
        resultsContainer.style.display = 'block';

        // 1st Try: Shopify Predictive Suggest API
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length > 0) {
              renderResults(products, query);
            } else {
              // 2nd Fallback Try: Fetch /products.json & filter client side
              fetch('/products.json?limit=50')
                .then(function (r) { return r.json(); })
                .then(function (pData) {
                  var allProds = (pData && pData.products) || [];
                  var qLower = query.toLowerCase();
                  var filtered = allProds.filter(function (item) {
                    var titleMatch = item.title && item.title.toLowerCase().indexOf(qLower) !== -1;
                    var typeMatch = item.product_type && item.product_type.toLowerCase().indexOf(qLower) !== -1;
                    var tagMatch = item.tags && item.tags.some(function (t) { return t.toLowerCase().indexOf(qLower) !== -1; });
                    return titleMatch || typeMatch || tagMatch;
                  });
                  renderResults(filtered, query);
                })
                .catch(function () {
                  renderResults([], query);
                });
            }
          })
          .catch(function () {
            // Fallback to /products.json
            fetch('/products.json?limit=50')
              .then(function (r) { return r.json(); })
              .then(function (pData) {
                var allProds = (pData && pData.products) || [];
                var qLower = query.toLowerCase();
                var filtered = allProds.filter(function (item) {
                  return item.title && item.title.toLowerCase().indexOf(qLower) !== -1;
                });
                renderResults(filtered, query);
              })
              .catch(function () {
                renderResults([], query);
              });
          });
      }, 250);
    }

    searchInput.addEventListener('input', doSearch);
    searchInput.addEventListener('keyup', doSearch);
    searchInput.addEventListener('focus', function () {
      if (searchInput.value.trim().length > 0) doSearch();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollHeader();
      initImageLoaders();
      initPredictiveSearch();
    });
  } else {
    initScrollHeader();
    initImageLoaders();
    initPredictiveSearch();
  }
})();
